import { INTERVENTION_EVENTS, QUOTE_EVENTS, INVOICE_EVENTS, JOB_REPORT_EVENTS, } from './event-names';
import { SITE_EVENTS } from './site-events';
import { EQUIPMENT_EVENTS } from './equipment-events';
import { NOTE_EVENTS } from './note-events';
export const InAppNotificationEventType = {
    INTERVENTION_CREATED: INTERVENTION_EVENTS.CREATED,
    INTERVENTION_STATUS_CHANGED: INTERVENTION_EVENTS.STATUS_CHANGED,
    INTERVENTION_ASSIGNED: INTERVENTION_EVENTS.TECHNICIAN_ASSIGNED,
    INTERVENTION_USER_ASSIGNED: INTERVENTION_EVENTS.USER_ASSIGNED,
    INTERVENTION_DATE_CHANGED: INTERVENTION_EVENTS.DATE_CHANGED,
    JOB_REPORT_SUBMITTED: JOB_REPORT_EVENTS.SIGNED,
    DISPUTE_REPORTED: INTERVENTION_EVENTS.DISPUTE_REPORTED,
    DISPUTE_UPDATED: INTERVENTION_EVENTS.DISPUTE_UPDATED,
    DISPUTE_RESOLVED: INTERVENTION_EVENTS.DISPUTE_RESOLVED,
    NOTE_ADDED: NOTE_EVENTS.CREATED,
    NOTE_REPLIED: NOTE_EVENTS.REPLIED,
    MENTION: NOTE_EVENTS.MENTION,
    DOCUMENT_UPLOADED: INTERVENTION_EVENTS.DOCUMENT_UPLOADED,
    SITE_CREATED: SITE_EVENTS.CREATED,
    SITE_IMPORTED: SITE_EVENTS.IMPORTED,
    EQUIPMENT_CREATED: EQUIPMENT_EVENTS.CREATED,
    QUOTE_CREATED: QUOTE_EVENTS.CREATED,
    QUOTE_SHARED: QUOTE_EVENTS.SHARED,
    INVOICE_CREATED: INVOICE_EVENTS.CREATED,
    INVOICE_SENT: INVOICE_EVENTS.SENT,
    INVOICE_PAYMENT_DECLARED: INVOICE_EVENTS.PAYMENT_DECLARED,
    // Nudge to SUPER_ADMIN on intervention close: a technician commission is now
    // billable (#1211). Distinct stored type (not the generic status change) so
    // the UI can surface "commission à facturer"; the derived to-invoice list
    // (#1212) is the authoritative safety net.
    COMMISSION_TO_INVOICE: 'commission.to_invoice',
};
/**
 * Event types whose resolver deliberately returns `entityId: null` — a
 * notification about a batch, not one row (#1481). `BaseNotificationResolver`
 * allows `null` through only for these; every other resolver still fails
 * closed on a falsy `entityId`.
 */
export const AGGREGATE_NOTIFICATION_EVENT_TYPES = new Set([InAppNotificationEventType.SITE_IMPORTED]);
